import { render, staticRenderFns } from "./ChangeAccount.vue?vue&type=template&id=61cce9c8&scoped=true"
import script from "./ChangeAccount.vue?vue&type=script&lang=js"
export * from "./ChangeAccount.vue?vue&type=script&lang=js"
import style0 from "./ChangeAccount.vue?vue&type=style&index=0&id=61cce9c8&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "61cce9c8",
  null
  
)

export default component.exports